import React from 'react'
import { makeStyles } from '@mui/styles'
import { formatCurrency } from '@/modules/_helpers/formatCurrency'

const AmountCell = (props) => {
  const { data: { bookingAmount } = {} } = props
  const classes = useStyles({ bookingAmount })

  return (
    <div className={classes.container}>
      <span className={classes.color}>{formatCurrency(bookingAmount)}</span>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    textAlign: 'right',
  },
  color: ({ bookingAmount }) => {
    return {
      color: bookingAmount > 0 ? theme.green : theme.red,
    }
  },
}))

export default AmountCell
